/**
* Gallery
*
* @author bjarke.rasmussen
*/
/*jslint plusplus: true, vars: true, browser: true, white:true*/
/*global define: true*/

'use strict';
// var GlueFrame = require('../../../../static/default/lib/GlueFrame/GlueFrame_in_webpack.js');

// Require dependencies for this module

var easeInExpo = function (x, t, b, c, d) {
    return (t == 0) ? b : c * Math.pow(2, 10 * (t / d - 1)) + b;
}

var easeOutExpo = function (x, t, b, c, d) {
    return (t == d) ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
}

var gallery = {

    init: function () {
        // var index = gallery.getIndex();

        $(document).on('click','.main-image[data-gallery]', function (e) {
            e.preventDefault();
            var index = $(this).parent().prevAll().length;
            gallery.showGallery(index);
        });
        
    },

    // getIndex: function () {
    //     var aThumb = $('.thumb');
    //     var index;
    //     for (var i = 0; i < aThumb.length; i++) {
    //         if (aThumb[i].classList.contains('active')) {
    //             index = i;
    //         }
    //     }
    //     return index;
    // },

    getImages: function () {
        var images = [];
        $('.main-image img').each(function () {
            if (!$(this).parent().hasClass('cloned')) {
                //  if ($(this).hasClass('pdp-video')){
                //      images.push({
                //          src: this,
                //          isVideo: true
                //      });
                //  }else{
                images.push({
                    src: this.getAttribute('data-gallery-src')
                 //   isVideo: false
                });
               //  }     
            }
        });

         return images;
     },

    getThumbnails: function () {
        var thumbnails = [];
        $('.main-image img').each(function () {
            thumbnails.push({
                src: this.getAttribute('data-gallery-src'),
                isVideo: false
            });
        });

        return thumbnails;
    },

    buildGallery: function () {

        var $gallery = $('<div class="data-gallery" data-gallery-index="1"></div>');

        var $galleryList = $('<div class="data-gallery__list owl-carousel" data-slider-id="galleryList"></div>');

        var $galleryListThumbs = $('<div class="data-gallery__thumbnails owl-thumbs" data-slider-id="galleryList"></div>');

        var images = gallery.getImages();
        
        var thumbnails = gallery.getThumbnails();

        $.each(thumbnails, function (i, imageObj) {
        	if(thumbnails.length > 1) {
        		$galleryListThumbs.append('<div class="data-gallery__thumb owl-thumb-item"><img alt="icon" src="' + imageObj.src + '" class="data-gallery__thumb__image"/></div>');
        	}
        });

        $.each(images, function (i, imageObj) {
            $galleryList.append('<div class="data-gallery__list__item"><img src="' + imageObj.src + '" class="data-gallery__list__item__image"/></div>');
        });

        $gallery.append('<a href="#" class="js-close-gallery data-gallery__close"></a>');
        $gallery.append($galleryList);
        $gallery.append($galleryListThumbs);

        return $gallery;
    },

    showGallery: function (i) {
    	var index = i;

        var $gallery = gallery.buildGallery();
        $('body').css({'overflow': 'hidden', 'position': 'fixed', 'width': '100%'}).append($gallery);
        var owl = $('.data-gallery__list');
        var loop = owl.find('.data-gallery__list__item').length > 1 ? true : false;
        owl.owlCarousel({
            lazyload: true,
            thumbs: true,
            thumbsPrerendered: true,
            items: 1,
            loop: loop,
            dots: false,
            nav: true,
            navText: [],
            margin: 0,
            startPosition: index,
            mouseDrag: false
        });
        
        owl.on('changed.owl.carousel', function (e) {
            $gallery.attr('data-gallery-index', e.item.index - (e.relatedTarget._clones.length / 2));
        });

        /*keyboard navigation*/
        $(document.documentElement).keyup(function(event) {    
            if (event.keyCode == 37) { /*left key*/
                owl.trigger('prev.owl.carousel');
            } else if (event.keyCode == 39) { /*right key*/
                owl.trigger('next.owl.carousel');
            }
        });

    //        if (window.innerWidth > 1023) {
    //            $('.data-gallery__list__item').zoom({
    //                on: 'grab',
    //                onZoomIn: function () {
    //                    $(this).prev().css('opacity', '0');
    //                },
    //                onZoomOut: function () {
    //                    $(this).prev().css('opacity', '');
    //                }
    //            });
    //        }

        $gallery.fadeIn(400,function(){
            
        });
        gallery.clickEvents($gallery);
        
    },

    goToSlide: function (index, $gallery, direction) {

        if (index == $gallery.attr('data-gallery-index')) {
            return false;
        }

        if (!direction) {
            if (index > $gallery.attr('data-gallery-index')) {
                var direction = 'right';
            } else {
                var direction = 'left';
            }
        }

        // Update current dot
        $gallery.find('.js-gallery-dot').removeClass('is-active');
        $gallery.find('.js-gallery-dot:nth-child(' + index + ')').addClass('is-active');

        // Slide images
        var $hideThisImage = $('.data-gallery__list__item').filter(function () {
            return $(this).css('opacity') == '1';
        });

        var $showThisImage = $gallery.find('.data-gallery__list__item:nth-child(' + index + ')');

        // Slide image. Either right or left
        if (direction == 'right') {
            $hideThisImage.removeAttr('style');
            setTimeout(function () {
                $showThisImage.css({
                    'left': '200px'
                }).animate({
                    'left': '0px',
                    'opacity': 1
                }, 250, 'easeOutExpo');
            }, 10);

        } else if (direction == 'left') {
            $hideThisImage.removeAttr('style');
            setTimeout(function () {
                $showThisImage.css({
                    'left': '-200px'
                }).animate({
                    'left': '0px',
                    'opacity': 1
                }, 250, 'easeOutExpo');
            }, 10);
        }

        // Update gallery data-gallery-index
        $gallery.attr('data-gallery-index', index);
    },

    clickEvents: function ($gallery) {

        $(document).on('keydown', galleryKeyDown);

        $gallery.on('click', '.js-close-gallery', function (e) {
            e.preventDefault();

            var index = $gallery.attr('data-gallery-index');
            $('.product-image-carousel').trigger('to.owl.carousel', index);

            $gallery.fadeOut(function () {
                $(this).remove();
                $('body').css({'overflow': '', 'position': '', 'width': ''});
            });
            $(document).off('keydown', galleryKeyDown);
        });

        $gallery.on('click', '.js-gallery-dot', function (e) {
            e.preventDefault();
            this.goToSlide($(e.currentTarget).attr('data-gallery-dot'), $gallery);
            $(document).off('keydown', galleryKeyDown);
        }.bind(this));

    }
}

function galleryKeyDown(e) {
    if (e.which == 27) {
        var index = $gallery.attr('data-gallery-index');
        $('.product-image-carousel').trigger('to.owl.carousel', index);
        $gallery.fadeOut(function () {
            $(this).remove();
            $('body').css({'overflow': '', 'position': '', 'width': ''});
        });
    }
}

module.exports = gallery;
